import * as React from 'react';
import { ITrack } from '../api';

interface IProps {
    track: ITrack
}
  
export class TrackInfo extends React.PureComponent<IProps> {
    public render() {
        const {track} = this.props;
        if (!track) {
            return null;
        }

        const {
            created_at,
        } = track;

        return (<div>
            <dl>
                <dt>Created At</dt>
                <dd>
                    { created_at }
                </dd>
            </dl>
        </div>);
    }
}

export default TrackInfo;



// WEBPACK FOOTER //
// ./src/components/TrackInfo.tsx